(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FAQ-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(){

  // accordion
  document.querySelectorAll(".faq-question").forEach(function(q){

    q.addEventListener("click",function(){

      let answer = this.nextElementSibling;

      if(answer.style.display == "block"){
        answer.style.display = "none";
      }else{
        answer.style.display = "block";
      }

    });

  });

  // category filter
  document.querySelectorAll(".faq-filter").forEach(function(btn){

    btn.addEventListener("click",function(){

      document.querySelectorAll(".faq-filter").forEach(b=>b.classList.remove("active"));
      this.classList.add("active");

      let cat = this.dataset.category;

      document.querySelectorAll(".faq-item").forEach(function(item){

        if(cat == "all" || item.dataset.category == cat.toLowerCase()){
          item.style.display = "block";
        }else{
          item.style.display = "none";
        }

      });

    });

  });

  // search
  document.getElementById("faqSearch").addEventListener("keyup", function(){

    let value = this.value.toLowerCase();

    document.querySelectorAll(".faq-item").forEach(function(item){

      let text = item.innerText.toLowerCase();

      item.style.display = text.includes(value) ? "block" : "none";

    });

  });

});

  } catch(e) { console.error(e); }
})();
})();
